import AdminLayout from "../../components/AdminLayout/AdminLayout";
import {Redirect, Route, Switch} from "react-router-dom";
import Users from "./pages/Users";
import User from "./pages/User";
import Collections from "./pages/Collections";
import Collection from "./pages/Collection";

export default function Admin() {
    return (
        <AdminLayout>
            <Switch>
                <Route exact path="/admin">
                    <Redirect to="/admin/users"/>
                </Route>
                <Route exact path="/admin/users" component={Users}/>
                <Route exact path="/admin/users/:id" component={User}/>
                <Route exact path="/admin/collections" component={Collections}/>
                <Route exact path="/admin/collections/:id" component={Collection}/>
            </Switch>
        </AdminLayout>
    )
}